import axios from 'axios';

export const multiUpdate = ({ selectedProject, ...rest }) =>
	axios.put(`/api/projects/${selectedProject}/multi-update`, { ...rest });

export const ss = () => null;
